import { useCallback, useEffect, useRef, useState } from 'react';

type UseAlbumRefreshBannerReturn = {
    isVisible: boolean;
    show: () => void;
};

const BANNER_DURATION_MS = 600000; // 10 minutes

const useAlbumRefreshBanner = (): UseAlbumRefreshBannerReturn => {
    const [isVisible, setIsVisible] = useState(false);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    const show = useCallback(() => {
        setIsVisible(true);

        // Clear any existing timer
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        // Set new timer to hide banner after 10 minutes
        timerRef.current = setTimeout(() => {
            setIsVisible(false);
        }, BANNER_DURATION_MS);
    }, []);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    return {
        isVisible,
        show
    };
};

export default useAlbumRefreshBanner;
